export const EnquiryStatusMap: Record<number, { label: string; color: string }> = {
  1: { label: "New", color: "primary" },
  2: { label: "Assigned", color: "warning" },
  3: { label: "In Follow Up", color: "info" },
  4: { label: "Joined", color: "success" },
  5: { label: "Not Interested", color: "danger" },
  6: { label: "DND", color: "dark" }
};

export const InterestLevelMap: Record<number, { label: string; color: string }> = {
  1: { label: "Hot", color: "danger" },
  2: { label: "Warm", color: "warning" },
  3: { label: "Cold", color: "secondary" },
  4: { label: "Not Interested", color: "dark" }
};

export const ResponseStatusMap: Record<number, { label: string; color: string }> = {
  1: { label: "Yes", color: "success" },
  2: { label: "No", color: "danger" },
  3: { label: "Later", color: "warning" },
  4: { label: "DND", color: "dark" }
};